export const UserRole = {
  Distributor: 'distributor',
  Dealer: 'dealer',
  SubDealer: 'subdealer',
  Admin: 'administrator',
  Calibrator: 'calibrator',
  Support: 'support',
};
